export default {
    diagnostic: {
        // Retrieves ICD categories
        icdCategories: {
            type: "get",
            error: {
                default: "Unable to load ICD categories.",
            },
        },

        // Retrieves ICDs under a given category ID
        icdsFromCategory: {
            type: "get",
            error: {
                default: "Unable to load ICDs.",
            },
        },
        /*Params:
        * - #categoryID: The category ID to load ICDs from
        */
        searchICDs: {
            type: "get",
            showLoader: false,
            error: {
                default: "Unable to load ICDs.",
            },
        },
        // Retrieves a patient's diagnoses
        diagnoses: {
            type: "get",
            error: {
                default: "Unable to load diagnoses.",
            },
        },
        /*Params:
        * - #patientID: The patient ID to load diagnoses for
        */

        // Adds or updates diagnosis
        saveDiagnosis: {
            type: "put",
            success: {
                201: "Successfully added diagnosis.",
                default: "Successfully saved diagnosis.",
            },
            error: {
                default: "Unable to save diagnosis.",
            },
        },
        delDiagnosis: {
            type: "put",
            error: {
                default: "Failed to delete diagnosis.",
            },
        },
        /*Params:
        * - #patientID: The patient which the diagnosis should be saved under
        */

        // Retrieves a patient's evaluations
        evaluations: {
            type: "get",
            error: {
                default: "Unable to load evaluations.",
            },
        },
        /*Params:
        * - #patientID: The patient ID to load evaluations for
        */
        // Gets a list of symptoms
        symptomList: {
            type: "get",
            error: {
                default: "Unable to load symptoms.",
            },
        },

        // Gets a list of interventions
        interventionList: {
            type: "get",
            error: {
                default: "Unable to load interventions.",
            },
        },
      
    },
    treatment: {
        getTreatmentPlan: {
            type: "get",
            error: {
                default: "Unable to get AI response.",
            },
        },

        getTreatmentTemplate: {
            type: "get",
            error: {
                default: "Unable to get treatment plan template.",
            },
        },
        getGoals: {
            type: "get",
            error: {
                default: "Unable to get patient goals.",
            },
        },
        getReference: {
            type: "get",
            error: {
                default: "Unable to get reference.",
            },
        },
        getTreatmentPlans: {
            type: "get",
            error: {
                default: "Unable to get treatment plans.",
            },
        },
        saveTreatmentPlan: {
            type: "put",
            success: {
                default: "Successfully saved treatment plan.",
            },
            error: {
                default: "Unable to save treatment plan.",
            },
        },
        saveTreatmentPlanAI: {
            type: "put",
            success: {
                default: "Successfully saved AI treatment plan.",
            },
            error: {
                default: "Unable to save AI treatment plan.",
            },
        },
        getTreatmentHistory: {
            type: "get",
            error: {
                default: "Unable to get treatment history.",
            },
        },
        getTreatmentHislist: {
            type: "get",
            error: {
                default: "Unable to get treatment history list.",
            },
        },
        editTreatmentTemplate: {
            type: "put",
            success: {
                default: "Successfully saved AI treatment plan template.",
            }, 
            error: {
                default: "Unable to save AI treatment plan template.",
            },
        },
        saveTreatmentTemplate: {
            type: "put",
            success: {
                default: "Successfully saved AI template.",
            },
            error: {
                default: "Unable to save AI template.",
            },
        },
    },
    assessment: {
        // Assigns assessments to provided patient
        assign: {
            type: "post",
            success: {
                default: "Successfully assigned assessments.",
            },
            error: {
                default: "Failed to assign assessments.",
            },
        },
        /* Params:
        * - ["]assessments: The assessment names to assign, as strings
        * - #patientID: The patient ID to assign the assessments to
        * - "message: The message to insert into the assessment email
        */

        // Lists assessments
        list: {
            type: "get",
            error: {
                default: "Unable to load assessments.",
            },
        },
        /*Params:
        * - #patientID?: The patient ID to load assessments for
        *  - Defaults to logged in patient
        * - "level: The level of assessments to load
        *  - Defaults to incomplete if patient logged in
        *  - Defaults to all if provider logged in
        *  - Possible values:
        *   - active (active assessments list)
        *   - all (all assessments a patient has completed)
        *   - latest (latest of each assessment a patient has completed)
        *   - incomplete (a patient's incomplete assessments)
        */

        // Fetches completion dates for patient and assessment
        completionDates: {
            type: "get",
            error: {
                default: "Unable to load completion dates.",
            },
        },
        /* Params:
        * - #patientID: The encoded patient ID to load completion dates for
        * - "assessmentID?: The assessment ID to load completion dates for
        */


        // Used for anonymous assessments
        bind: {
            type: "put",
            error: {
                redirect: "/",
                default: "Unable to bind assessment.",
            },
        },
        /* Params:
        * - "a: The encoded assessment ID to bind
        * - "p: The encoded patient ID to bind
        */

        // Fetches questions for bound or provided assessment
        questions: {
            type: "get",
            error: {
                redirect: "/",
                default: "Unable to load questions.",
            },
        },
        /* Params:
        * - "assessmentID?: The assessment ID to load questions for
        *   - Defaults to bound assessment ID
        * - #patientID?: The encoded patient ID to load questions for
        *  - Defaults to logged in or bound patient ID
        */

        // Gets saved answers for bound or provided assessment
        getAnswers: {
            type: "get",
            error: {
                redirect: "/",
                default: "Unable to load answers.",
            },
        },
        /* Params:
        * - "assessmentID?: The assessment ID to get answers for
        *  - Defaults to bound assessment ID
        * - #patientID?: The encoded patient ID to get answers for
        *   - Defaults to logged in or bound patient ID
        * - "date?: The date to fetch assessments for.
        *   - Defaults to most recent assessment date
        */

        // Saves answers for bound or provided assessment
        saveAnswers: {
            type: "put",
            success: {
                default: "Successfully saved answers.",
            },
            error: {
                default: "Unable to save answers.",
            },
        },
        submitAnswers: {
            type: "put",
            success: {
                default: "Successfully Submitted answers.",
            },
            error: {
                default: "Unable to save answers.",
            },
        },
        /* Params:
        * - "assessmentID?: The assessment ID to load questions for
        *  - Defaults to bound assessment ID
        * - #patientID?: The encoded patient ID to bind
        * - Defaults to logged in or bound patient ID
        * - <"+>answers: The assessment answers to save
        */
        requestUnlock: {
            type: "post",
            success: {
                default: "Successfully unlock assessment.",
            },
            error: {
                default: "Unable to unlock assessment.",
            },
        },
        outcomeList: {
            type: "get",
            error: {
                default: "Unable to load outcomelist.",
            },
        },
        sendOutcomeEmail: {
            type: "post",
            success: {
                default: "Successfully send outcome measure email.",
            },
            error: {
                default: "Unable to send outcome measure email.",
            },
        },
    },

    ai: {
        getAIResponse: {
            type: "get",
            error: {
                default: "Unable to get AI response.",
            },
        },
        getAIResponsePatient: {
            type: "get",
            error: {
                default: "Unable to get AI response.",
            },
        },
    },
};